import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-online-training',
  templateUrl: './online-training.component.html',
  styleUrls: ['./online-training.component.scss']
})
export class OnlineTrainingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
